export default {
  getList(state) {
    return state.list;
  },

  getPageInfo(state) {
    return state.pageInfo;
  },

  getDetail(state) {
    return state.detail;
  }
};
